// import rpcHeaders from '#/store/headers';

export function emptyState() {
  return {
    toggleState: '',
  };
}

export const getters = {
  getToggleState: (state) => (state.toggleState ? state.toggleState : window.localStorage.getItem('lastActiveToggleState')),
};

export const mutations = {
  setToggleStateMode: (state, viewType) => {
    if (state.toggleState !== viewType) {
      state.toggleState = viewType;
      window.localStorage.setItem('lastActiveToggleState', viewType);
      console.info('change toggle state : ', viewType);
    }
  },
};

export const actions = {
  setToggleState: ({ commit }, viewType) => {
    console.log('Reset toggleState flag to ', viewType);
    commit('setToggleStateMode', viewType);
    return viewType;
  },
};

export default {
  namespaced: true,
  state: emptyState(),
  getters,
  mutations,
  actions,
};
